// Google Ads Banner Component
// Replace with your actual Google AdSense code
export default function AdBanner({ format = 'auto', slot = '' }) {
  return (
    <div className="w-full bg-gray-100 rounded-lg p-4 flex items-center justify-center min-h-[100px] border border-gray-200">
      {/* Placeholder for Google AdSense */}
      <div className="text-center text-gray-500 text-sm">
        <p>Advertisement</p>
        <p className="text-xs mt-1">Ad space for Google Ads</p>
      </div>
      
      {/* Uncomment and add your Google AdSense code here */}
      {/* 
      <ins
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client="ca-pub-XXXXXXXXXXXXXXXX"
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive="true"
      />
      <script>
        (adsbygoogle = window.adsbygoogle || []).push({});
      </script>
      */}
    </div>
  )
}

